<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reject-btn.btn {
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #fb2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.pass-btn.btn {
  background: #f2fff5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1ba854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #ff991c;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #f5f5f5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.sanButton {
  float: left;
}

.sanButton .el-button--mini {
  margin: 10px 0;
  margin-left: 10px;
}

.content-main-box .el-table {
  margin-bottom: 50px !important;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div" style="width: 96px">提交人：</div>
          <el-input
            size="mini"
            v-model="page.staffName"
            class="fl"
            style="width: 260px"
            placeholder="请输入客户名称"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div" style="width: 96px">审批状态：</div>
          <el-select
            size="mini"
            v-model="page.approveState"
            class="fl"
            style="width: 260px"
            placeholder="请选择审批状态"
            filterable
          >
            <el-option
              v-for="item in approveStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div" style="width: 104px">数据所属人员：</div>
          <el-input
            size="mini"
            v-model="page.param1"
            class="fl"
            style="width: 200px"
            placeholder="请输入数据所属人员"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div" style="width: 96px">提交日期：</div>
          <el-date-picker
            size="mini"
            v-model="timeListS"
            type="daterange"
            range-separator="至"
            class="fl"
            style="width: 260px"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top: 20px">
        <el-col :span="6">
          <div class="search-area-div" style="width: 96px">流程名称：</div>
          <el-input
            size="mini"
            v-model="page.flowName"
            class="fl"
            style="width: 260px"
            placeholder="请输入流程名称"
          ></el-input>
        </el-col>
        <el-col :span="6" style="text-align: left">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
      <div class="sanButton">
        <el-button
          size="mini"
          type="info"
          approveSuggest=""
          @click="batchApprovalPassed"
          >批量审批通过</el-button
        >
        <el-button
          size="mini"
          type="danger"
          approveSuggest=""
          @click="bulkApprovalRejection"
          >批量审批驳回</el-button
        >
        <el-button
          size="mini"
          plain
          approveSuggest=""
          @click="bulkApprovalRevocation"
          >批量审批撤消</el-button
        >
      </div>
      <el-table
        :height="height"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
      >
        <!-- :disabled="scope.row.approveState==A"-->

        <el-table-column type="selection" width="55" :selectable="selectable">
        </el-table-column>

        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="templateName"
          label="流程名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.flowName }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="数据所属人员"
          header-align="center"
          align="left"
          width="380"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="`电话号: ${scope.row.param3}`"
              placement="top"
            >
              <span
                class="specialHandling"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                v-if="scope.row.param1"
                >{{ scope.row.param1 }}-{{ scope.row.param2 }}-{{
                  scope.row.param3
                }}</span
              >
              <span v-else>-</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="审批状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <a class="reject-btn btn" v-if="scope.row.approveState == 'R'"
              >已驳回</a
            >
            <a class="pass-btn btn" v-if="scope.row.approveState == 'Y'"
              >已通过</a
            >
            <a class="ing-btn btn" v-if="scope.row.approveState == 'A'"
              >审批中</a
            >
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'N'"
              >草稿中</a
            >
            <a class="cancel-btn btn" v-if="scope.row.approveState == 'C'"
              >已撤销</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="通过/驳回原因"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{
            scope.row.approveSuggest || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="提交人"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{
            scope.row.staffName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="所在部门"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{
            scope.row.organisationName || "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="所在岗位"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.positionName }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="140"
          label="提交时间"
          header-align="center"
          align="left"
          sortable
        >
          <template slot-scope="scope">{{
            scope.row.createTime | getTime
          }}</template>
        </el-table-column>

        <el-table-column
          prop="bank"
          min-width="130px"
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <!--已驳回 已撤销  -->
            <div
              v-if="
                scope.row.approveState == 'R' || scope.row.approveState == 'C'
              "
            >
              <a class="txt-color" @click="seeForm(scope.row)">详情</a>

              <span
                @click="dgsdhSa(scope.row)"
                v-if="scope.row.staffGuid == userinfos.staffGuid"
              >
                <a
                  class="txt-color"
                  @click="delForm(scope.row, scope.row.guid)"
                >
                  | 删除</a
                >
              </span>
            </div>
            <!-- 已通过 -->
            <div v-if="scope.row.approveState == 'Y'">
              <a class="txt-color" @click="seeForm(scope.row)">详情</a>
            </div>

            <!-- 审批中 -->
            <!-- <div v-if="scope.row.approveState == 'A'">
                            <a class="txt-color" v-if="scope.row.staffGuid == staffGuid"
                                @click="toRevoke(scope.row)">撤销｜</a>
                              
                            <a class="txt-color" v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                                @click="passDialogVisible = true; approveSuggest = ''; form = scope.row;">通过｜</a>
                            <a class="txt-color" v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                                @click="rejectDialogVisible = true; approveSuggest = ''; form = scope.row;">驳回｜</a>
                            <a class="txt-color" @click="seeForm(scope.row)">详情</a>
                        </div> -->
            <div v-if="scope.row.approveState == 'A'">
              <a
                class="txt-color"
                v-if="scope.row.staffGuid == staffGuid"
                @click="toRevoke(scope.row)"
                >撤销｜</a
              >

              <a
                class="txt-color"
                v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="
                  passDialogVisible = true;
                  approveSuggest = '';
                  form = scope.row;
                "
                >通过｜</a
              >

              <a
                class="txt-color"
                v-if="scope.row.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="
                  rejectDialogVisible = true;
                  approveSuggest = '';
                  form = scope.row;
                "
                >驳回｜</a
              >

              <a class="txt-color" @click="seeForm(scope.row)">详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog
        title="驳回流程"
      :visible.sync="rejectDialogVisible"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        maxlength="100"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggest"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()"
          >驳回</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="填写通过备注"
      :visible.sync="passDialogVisible"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        maxlength="100"
        :rows="5"
        placeholder="请填写通过备注（选填）"
        v-model="approveSuggest"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()"
          >通过</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量通过 -->
    <el-dialog
      title="填写通过备注"
      :visible.sync="passDialogVisibles"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        maxlength="100"
        :rows="5"
        placeholder="请填写通过备注（选填）"
        v-model="approveSuggests"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmits()"
          >通过</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量驳回 -->
    <el-dialog
      title="驳回流程"
      :visible.sync="rejectDialogVisibles"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        maxlength="100"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggests"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmitss()"
          >驳回</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      approveSuggests: "",
      passDialogVisibles: false,
      rejectDialogVisibles: false,
      height: window.innerHeight - 260,
      contentMainHeight: window.innerHeight - 240,
      fullscreenLoading: false,
      staffGuid: userinfo.staffGuid,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        flowTypeList: ["00100", "00101", "00102"], //花名册新增：00100 花名册变更：00101 花名册删除：00102
        appSideType: 1, //端 1运营端 2药企端 3移动端
        staffName: null, //提交人
        startTime: null, //开始日期
        endTime: null, //结束日期
        param1: null,
        // listType:1,
        staffGuid: userinfo.staffGuid,
        staffLevel:[]
      },
      timeListS: [],
      approveStateList: [
        { label: "已通过", value: "Y" },
        { label: "已驳回", value: "R" },
        { label: "审批中", value: "A" },
        { label: "已撤销", value: "C" },
      ],
      sendTenantList: [],
      tableData: [],
      approveSuggest: "",
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: "",
      //创建时间
      createtimeArr: [],
      //操作
      multipleSelection: [],
      //批量数组
      bulkArr: [],
      //  审批的数组
      approvalArr: [],
      // 撤销数组
      quashArr: [],
      //账号信息
      userinfos: {},
      uniquePeople: [],
    };
  },
  created() {
    if (this.$route.query.approveState) {
      this.page.approveState = this.$route.query.approveState
    }
    this.getList();
    // this.invertedChange()
    this.dgsdhSa();    
    this.toggleSelection();
  },
  mounted() {},
  methods: {
    dgsdhSa() {
      //控制删除键
      this.userinfos = JSON.parse(localStorage.userInfo);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        // this.$refs.multipleTable.clearSelection();
      }
    },

    handleSelectionChange(val) {
      let self = this;
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 批量通过

    batchApprovalPassed() {
      this.passDialogVisibles = true;
    },
    //多选框是否可选
    selectable(row, index) {
      return (
        (row.approveStaffGuids &&
          row.approveStaffGuids.indexOf(this.staffGuid) > -1 &&
          row.approveState == "A") || (row.staffGuid == this.staffGuid&&row.approveState == "A")
      );
    },

    //弹框确认
    toPassSubmits() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let self = this;
      //赛选待审核的户籍
      (self.bulkArr = []), (self.approvalArr = []);
      self.multipleSelection.forEach((item) => {
        if (item.approveState == "A") {
          self.approvalArr.push(item);
          console.log(self.approvalArr, "赛选待审核的户籍");
        }
      });

      //请求需要的数据
      self.approvalArr.forEach((item) => {
        self.bulkArr.push({
          approveStaffGuid: userinfo.staffGuid,
          approveSuggest: this.approveSuggests,
          flowType: item.flowType,
          funcCode: item.funcCode,
          guid: item.guid,
        });
        console.log(self.bulkArr, "请求需要的数据");
      });
      //清除重复的数据
      self.uniquePeople = self.bulkArr.filter((item, index, selfs) => {
        return index === selfs.findIndex((t) => t.guid === item.guid);
      });

      console.log(self.uniquePeople);
      // if(this.bulkArr.length===0){
      //   this.$message.success('请选择数据');
      // }else{
      if (self.uniquePeople.length > 0) {
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/batch-allow-flow`,
            self.uniquePeople
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // console.log(res,'ljx');
              self.fullscreenLoading = false;
              this.$message.success(res.data.msg);
              this.getList();
              this.passDialogVisibles = false;
              this.approveSuggests = "";
            } else {
              self.$message.error(res.data.msg);
              this.passDialogVisibles = false;
            }
          });
      } else {
        this.$message.error("请选择数据!");
        this.approveSuggests = "";
      }
    },
    // 批量审批驳回
    bulkApprovalRejection() {
  
      this.rejectDialogVisibles = true;
    },
    toRejectSubmitss() {

      let self = this;
       if (this.approveSuggests === "") {
        console.log(111);
        this.$message.error("请填写驳回理由！");
        return;
      }
      
      let userinfo = JSON.parse(localStorage.userInfo);
      //赛选待审核的户籍
      (self.bulkArr = []), (self.approvalArr = []);
      self.multipleSelection.forEach((item) => {
        if (item.approveState == "A") {
          self.approvalArr.push(item);
          console.log(self.approvalArr, "赛选待审核的户籍");
        }
      });

      //请求需要的数据
      self.approvalArr.forEach((item) => {
        self.bulkArr.push({
          approveStaffGuid: userinfo.staffGuid,
          approveSuggest: this.approveSuggests,
          flowType: item.flowType,
          funcCode: item.funcCode,
          guid: item.guid,
        });
        console.log(self.bulkArr, "请求需要的数据");
      });
      //清除重复的数据
      self.uniquePeople = self.bulkArr.filter((item, index, selfs) => {
        return index === selfs.findIndex((t) => t.guid === item.guid);
      });

      console.log(self.uniquePeople);
      if (self.uniquePeople.length > 0) {
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/batch-backup-flow`,
            self.uniquePeople
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // console.log(res,'ljx');
              self.fullscreenLoading = false;
              this.$message.success(res.data.msg);
              this.getList();
              this.rejectDialogVisibles = false;
              this.approveSuggests = "";
            } else {
              self.$message.error(res.data.msg);
              this.rejectDialogVisibles = false;
              this.approveSuggests = "";
            }
          });
      } else {
        self.$message.error("请选择数据!");
      }
    },
    //批量审批撤消
    bulkApprovalRevocation() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let self = this;
      //赛选待审核的户籍
      self.bulkArr = [];
      self.approvalArr = [];
      // !拦截非当前人发起的
      if (!self.multipleSelection.every(item=>item.staffGuid === this.staffGuid)) {
        this.$message.warning("请勾选自己发起的审批流");
        return
      }
      self.multipleSelection.forEach((item) => {
        if (item.approveState == "A") {
          self.approvalArr.push(item);
        }
      });

      //请求需要的数据
      self.approvalArr.forEach((item) => {
        self.bulkArr.push({
          approveStaffGuid: userinfo.staffGuid,
          approveSuggest: this.approveSuggests,
          flowType: item.flowType,
          funcCode: item.funcCode,
          guid: item.guid,
        });
      });
      //清除重复的数据
      self.uniquePeople = self.bulkArr.filter((item, index, selfs) => {
        return index === selfs.findIndex((t) => t.guid === item.guid);
      });

      console.log(self.uniquePeople);
      
      if (self.uniquePeople.length > 0) {
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/batch-canal-flow`,
            self.uniquePeople
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // console.log(res,'ljx');
              self.fullscreenLoading = false;
              this.$message.success("审批撤消！");
              this.getList();
              this.rejectDialogVisibles = false;
              this.approveSuggests = "";
            } else {
              self.$message.error(res.data.msg);
              self.fullscreenLoading = false;
              this.rejectDialogVisibles = false;
              this.approveSuggests = "";
            }
          }).catch(()=>{
            self.fullscreenLoading = false;
          })
      } else {
        self.$message.error("请选择数据!");
      }
    },
    nalos() {
      const value = localStorage.getItem("reportMenuList");
      const val = JSON.parse(value);
      console.log(val);
    },
    search() {
      let self = this;
      self.tableLoading = true;
      if (this.timeListS.length) {
        self.page.startTime = self
          .$moment(self.timeListS[0])
          .format("YYYY-MM-DD HH:mm:ss");
        self.page.endTime = self
          .$moment(self.timeListS[1])
          .format("YYYY-MM-DD 23:59:59");
      }
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/get-flow-list`,
          this.page
        )
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            console.log(self.tableData);
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
            self.page.param1 = self.tableData.param1;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        flowTypeList: ["00100", "00101", "00102"], //花名册新增：00100 花名册变更：00101 花名册删除：00102
        appSideType: 1, //端 1运营端 2药企端 3移动端
        staffName: null, //提交人
        startTime: null, //开始日期
        endTime: null, //结束日期,
      };
      this.timeListS = [];
      this.getList();
    },
    getList() {
      if (sessionStorage.getItem("pageIndex")) {
        this.page.pageIndex = sessionStorage.getItem("pageIndex");
        sessionStorage.removeItem("pageIndex");
      }
      let self = this;
      self.tableLoading = true;

      let query = {
        orderByName: "create_time",
        orderByType: "desc",
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/get-flow-list`,
          Object.assign(this.page, query)
        )
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log("创建", res);
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
            // self.createtimeArr=res.data.data.records.createTime
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //删除
    delForm(data, guid) {
      console.log(data.staffName == this.userinfos.positionNames);
      var self = this;
      self
        .$confirm("删除后不可恢复，确定删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/work-flow/data/remove-approve-by-guids`,
              [guid]
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success("删除成功");
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
      // }
    },

    //详情
    seeForm(res) {
      console.log(res);
      sessionStorage.setItem("pageIndex", this.page.pageIndex);
      this.$router.push({
        path: "/brokerInsuredApprovalDetail",
        query: {
          form: encodeURIComponent(JSON.stringify(res)),
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest === "") {
        console.log(111);
        this.$message.error("请填写驳回理由！");
        return;
      }
      let query = {
        guid: this.form.guid,
        flowType: this.form.flowType,
        funcCode: this.form.funcCode,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`,
          query
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.rejectDialogVisible = false;
            this.$message.success("驳回成功！");
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //通过
    toPassSubmit() {
      // if(this.bulkArr){
      //   this.batchApprovalPassed()
      // }else{}
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.guid,
        flowType: this.form.flowType,
        funcCode: this.form.funcCode,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`,
          query
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success("审批通过！");
            this.getList();
         
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //撤回
    toRevoke(form) {
      let self = this;
      this.$confirm("确定撤销吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = {
            guid: form.guid,
            flowType: form.flowType,
            approveStaffGuid: form.staffGuid,
            funcCode: form.funcCode,
          };
          self.fullscreenLoading = true;
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`,
              query
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success("撤销成功！");
                this.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消操作！",
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    //根据创建时间进行倒排
    // invertedChange(){
    //   // self.createtimeArr
    //     let query = {
    //             orderByName: self.createtimeArr,
    //             orderByType : desc
    //         };
    //      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
    //             if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //                 console.log(res);
    //             } else {
    //                 self.$message.error(res.data.msg);
    //             }
    //         });
    //  }
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>
